





















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Franchise, Office } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';

@Component
export default class Footer extends Vue {
  private cityOffice: Office | null = null;

  private redlynchOffice: Office | null = null;

  private southOffice: Office | null = null;

  private franchise: Franchise | null = null;

  public get logo(): string {
    return this.$route.meta.logo || 'generic';
  }

  mounted() {
    this.loadOffices();
  }

  loadOffices(): void {
    API.Offices.Get('91b553f9-7cbc-4697-bf7d-d70714b674a4').then((office) => {
      this.cityOffice = office;
    });

    API.Offices.Get('f2c947c3-1b35-41ce-8380-54f0ff32cd52').then((office) => {
      this.redlynchOffice = office;
    });

    API.Offices.Get('f9d229bb-51ff-4b83-94eb-4877c1c736d2').then((office) => {
      this.southOffice = office;
    });

    API.Franchises.Get(Config.Website.Settings!.WebsiteId).then((franchise) => {
      this.franchise = franchise;
    });
  }

  // eslint-disable-next-line
  scrollToTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  // eslint-disable-next-line
  get year(): string {
    return new Date().getFullYear().toString();
  }

  get hideMap(): boolean {
    return this.$route.meta?.hideOfficeMap;
  }
}
